// src/components/ToastNotification.jsx
import React, { useEffect, useState } from 'react';
import '../../styles/ToastNotification.css';

const ToastNotification = ({ message, statusCode, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Determine color based on status code
  const getStatusColor = () => {
    if (statusCode >= 200 && statusCode < 300) {
      return 'success'; // Green for success
    } else if (statusCode >= 300 && statusCode < 400) {
      return 'info'; // Blue for redirects
    } else if (statusCode === 400) {
      return 'warning'; // Orange for bad request
    } else if (statusCode === 401) {
      return 'warning'; // Orange for unauthorized
    } else if (statusCode === 403) {
      return 'warning'; // Orange for forbidden
    } else if (statusCode === 404) {
      return 'error'; // Black for not found
    } else if (statusCode >= 500) {
      return 'error'; // Red for server errors
    } else {
      return 'default'; // Gray for others
    }
  };
  
  // Get icon based on status
  const getStatusIcon = () => {
    const color = getStatusColor();
    switch (color) {
      case 'success':
        return '✓';
      case 'info':
        return 'ℹ';
      case 'warning':
        return '⚠';
      case 'error':
        return '✕';
      default:
        return 'ℹ';
    }
  };
  
  // Get status text
  const getStatusText = () => {
    if (statusCode >= 200 && statusCode < 300) {
      return 'Success';
    } else if (statusCode >= 300 && statusCode < 400) {
      return 'Redirect';
    } else if (statusCode === 400) {
      return 'Bad Request';
    } else if (statusCode === 401) {
      return 'Unauthorized';
    } else if (statusCode === 403) {
      return 'Forbidden';
    } else if (statusCode === 404) {
      return 'Not Found';
    } else if (statusCode >= 500) {
      return 'Server Error';
    } else {
      return 'Info';
    }
  };
  
  useEffect(() => {
    // Show toast when component mounts
    setIsVisible(true);
    
    // Auto-hide after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Allow time for exit animation
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [onClose]);
  
  const colorClass = getStatusColor();
  const icon = getStatusIcon();
  const statusText = getStatusText();
  
  return (
    <div className={`toast-notification ${colorClass} ${isVisible ? 'show' : ''}`}>
      <div className="toast-icon">{icon}</div>
      <div className="toast-content">
        <div className="toast-status">{statusText} ({statusCode})</div>
        <div className="toast-message">{message}</div>
      </div>
      <button className="toast-close" onClick={() => {
        setIsVisible(false);
        setTimeout(onClose, 300);
      }}>✕</button>
    </div>
  );
};

export default ToastNotification;